<app-sign-up-step1 *ngIf="isStep1"></app-sign-up-step1>
<app-sign-up-step2 *ngIf="!isStep1"></app-sign-up-step2>
